// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"225":"a65789d6","334":"67d1f8ac"}[chunkId] + ".chunk.css";
};